<script lang="ts" setup>
  import { ref } from 'vue';

  const open = ref(true);
</script>
<template>
  <UiModal v-model:open="open" medium visitable aria-labelledby="cart-wishlist-import-heading" aria-describedby="cart-wishlist-import-description">
    <SfHeading type="h2" id="cart-wishlist-import-heading">
      {{ $t('SHOP.CART.HEADER.IMPORT_CART_FROM_FILE') }}
    </SfHeading>
    <FormController :action="$route('web.cart.import.store')" method="POST" v-slot="{ processing, submit }">
      <p id="cart-wishlist-import-description">{{ $t('SHOP.CART.MESSAGE.IMPORT_CART_FROM_FILE') }}</p>
      <div class="file-wrapper">
        <SfFormInput :label="$t('SHOP.CART.LABEL.CHOOSE_FILE')" type="file" name="file" required />
      </div>
      <SfModalFooter>
        <SfButton :href="$route('web.cart.show')">
          {{ $t('SHOP.ACTION.CANCEL') }}
        </SfButton>
        <SfButton :loading="processing" primary type="submit" @click="submit">
          {{ $t('SHOP.ACTION.SAVE') }}
        </SfButton>
      </SfModalFooter>
    </FormController>
  </UiModal>

  <RouterView />
</template>
<style lang="scss" scoped>
  .file-wrapper {
    margin: 1rem 0;
  }
</style>
